import Component from 'Component';

export default class Events extends Component {

  configure() {
    this.topics = {};
    return super.configure();
  }

  initialize() {
    return super.initialize();
  }

  /**
   * Subscribes to topic
   *
   * @param topic
   * @param listener
   * @returns {{remove: remove}}
   */
  subscribe(topic, listener) {

    // Create the topic's object if not yet created
    if (!this.topics.hasOwnProperty.call(this.topics, topic)) {
      this.topics[topic] = [];
    }

    // Add the listener to queue
    let index = this.topics[topic].push(listener) - 1;

    // Provide handle back for removal of topic
    return {
      remove: () => {
        delete this.topics[topic][index];
      }
    }

  }

  /**
   * Publish data to topic
   *
   * @param topic
   * @param data
   */
  publish(topic, data) {

    // If the topic doesn't exist, or there's no listeners in queue, just leave
    if (!this.topics.hasOwnProperty.call(this.topics, topic))
      return;

    // Cycle through topics queue
    this.topics[topic].forEach((listener) => {
      listener(data);
    });

  }

}